/* eslint-disable no-useless-escape */
/*
 * @Author: caoqingda
 * @Date: 2019-10-30 15:44:20
 * @Last Modified by: caoqingda
 * @Last Modified time: 2020-11-17 16:59:57
 */
import native from '@zz-common/native-adapter'
import CryptoJS from 'crypto-js'
import { cookie, env } from '@zz-common/zz-utils'
import { zljUserLogin } from '../api/resourceApi'
import { Toast } from '@zz-common/zz-ui'
/**
 * 比较两个app版本
 * @param per:当前版本
 * @param nxt：需要比对的版本
 * return 如果比对版本号 >= 版本号，返回true
 */
const flatten = (ary) => {
  return ary.reduce((pre, cur) => {
    return pre.concat(Array.isArray(cur) ? flatten(cur) : cur)
  }, [])
}
export const compareVersion = (per = '', nxt = '') => {
  if (!per) return false
  console.log('per', per)
  const a = flatten(per.split('.').map((item) => item.split('_')))
  const b = flatten(nxt.split('.').map((item) => item.split('_')))
  for (let i = 0; i < a.length; i++) {
    const perItem = Number(a[i]) || 0
    const nxtItem = Number(b[i]) || 0
    if (perItem > nxtItem) return true
    if (perItem === nxtItem) {
      if (i === a.length - 1) return true
      continue
    }
    if (perItem < nxtItem) return false
  }
}
//判断当前app，用于监控埋点
//当有新app接入时在appList中增加
export const curApp = () => {
  const appList = ['zz', 'zlj', 'zzqcidentity']
  for (const app of appList) {
    if (native.in(app)) return app
  }
  return ''
}
export const AndroidZZ = 'https://app.zhuanzhuan.com/zz/redirect/download?channelId=788'
export const IosZZ =
  'https://apps.apple.com/cn/app/%E8%BD%AC%E8%BD%AC%E4%BA%8C%E6%89%8B%E4%BA%A4%E6%98%93%E7%BD%91-%E4%B8%80%E4%B8%AA%E5%B8%AE%E4%BD%A0%E8%B5%9A%E9%92%B1%E7%9A%84%E7%BD%91%E7%AB%99/id1002355194'
export const getDownAppUrl = () => {
  const { android } = detectOS()
  const appV = native.client //zzseller卖家app zz主zpp
  console.log('appV', appV)
  console.log('android', android)
  if (appV === 'zz') return android ? AndroidZZ : IosZZ
  return ''
}
// 检测设备类型
export const detectOS = () => {
  const ua = navigator.userAgent
  const ipad = /(iPad).*OS\s([\d_]+)/.test(ua)
  const iphone = !ipad && /(iPhone\sOS)\s([\d_]+)/.test(ua)
  const android = /(Android);?[\s/]+([\d.]+)?/.test(ua)

  const os = android ? 'android' : 'ios'
  const ios = iphone || ipad

  return {
    os,
    ios,
    ipad,
    iphone,
    android
  }
}
/**
 * 获取指定 Cookie 值
 * @param {String} k 指定的 Cookie 名
 */
export function getCookie(k) {
  const res = RegExp('(^|; )' + encodeURIComponent(k) + '=([^;]*)').exec(document.cookie)
  return res && res[2]
}

/**
 * 设置指定 Cookie 值
 * @param {String} k 指定的 Cookie 名
 */

export function setCookie(name, value, expriesDays, isEncode = true) {
  const Days = expriesDays || 20
  const exp = new Date()
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  // 测试用，cookie有效期2分钟
  // exp.setTime(exp.getTime() + 2*60*1000)
  document.cookie =
    name + '=' + isEncode ? escape(value) : value + ';domain=zhuanzhuan.com;path=/;expires=' + exp.toGMTString()
}

/**
 * 获取 url 参数字典
 */
export function queryParams() {
  const _reg = /([\?&])([^\?&#]*)=([^&|#|\?]*)/g;
  const result = {};
  const matchArr = location.href.match(_reg) || [];
  matchArr.forEach(function(v) {
    const str = v.substring(1);
    if (str) {
      result[str.split('=')[0]] = str.split('=')[1];
    }
  });
  console.log('打印全局链接参数', result)
  return result;
}

/**
 * querySelector
 * @param {Selector} selectors CSS 选择器
 */
export function $(selectors) {
  return document.querySelector(selectors)
}
/**
 * querySelectorAll
 * @param {Selector} selectors CSS 选择器
 */
export function $$(selectors) {
  return document.querySelectorAll(selectors)
}

/**
 * 判断元素是否滑动到底部
 * e.scrollTop —— 获取滚动条当前的位置
 * e.offsetHeight —— 获取当前可视范围的高度
 * e.scrollHeight —— 获取元素完整的高度
 */
export function isScrollToBottom(e = {}) {
  // console.log('getScrollTop + getClientHeight: ' + (e.scrollTop + e.offsetHeight));
  const { scrollTop = 0, offsetHeight = 0, scrollHeight = 1000 } = e
  console.log('!!!!!!!!!!!!!!!!: ')
  console.log('eeeeeeeeeeee: ' + e)
  console.log('scrollTop: ' + scrollTop)
  console.log('offsetHeight: ' + offsetHeight)
  console.log('getDocHeight: ' + scrollHeight)
  console.log('result: ' + !!(scrollTop + offsetHeight + 100 >= scrollHeight))
  //if (e.scrollTop === undefined || e.offsetHeight === undefined || e.scrollHeight === undefined) return false;
  return scrollTop + offsetHeight + 200 >= scrollHeight
}
export function isDocumentBottom() {
  // var b = document.body;
  // console.log('window: ' + window.scrollY + '\t\t' + window.innerHeight + '\t\t' + window.outerHeight);
  // console.log('body: ' + b.scrollTop + '\t\t' + b.scrollHeight + '\t\t' + b.clientHeight + '\t\t' + b.offsetHeight);
  return window.scrollY + window.innerHeight * 2 > document.body.scrollHeight
}

export const deviceType = (function() {
  const ua = window.navigator.userAgent
  return {
    Mobile: !!ua.match(/AppleWebKit.*Mobile.*/i), // 移动端
    iOS: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i), // ios
    iPhone: !!ua.match(/iPhone/i), // iphone
    iPad: !!ua.match(/iPad/i), // ipad
    Android: !!ua.match(/Android/i) // android
  }
})()

/**
 * 登录
 */
export function login() {
  return new Promise((resolve, reject) => {
    if (getCookie('PPU') && parseInt(getCookie('uid')) > 0) {
      resolve()
    } else {
      native.wrap('login')((res) => {
        if (Number(res.code) === 0) {
          //  在 iOS 下刚登陆后存在没有 cookie 的情况
          if (deviceType.iOS) {
            native.wrap('getCookie')(() => {})

            const startTime = new Date().getTime()
            const timer = setInterval(() => {
              const uid = getCookie('uid')
              const diffTime = new Date().getTime() - startTime
              if (diffTime > 1000 || uid) {
                console.log('got uid: ', uid)
                clearInterval(timer)
                resolve()
              }
            }, 100)
          } else {
            resolve()
          }
        } else {
          //  res.code == -100    登录失败
          //  res.code == -1      登录失败，比如用户取消，不做任何处理
          reject(res)
        }
      })
    }
  })
}
/**
 * 日期格式化
 * @param {String} fmt 日期格式
 */
// eslint-disable-next-line
Date.prototype.format = function(fmt) {
  const weeks = ['日', '一', '二', '三', '四', '五', '六']
  const year = this.getFullYear()
  const month = this.getMonth() + 1
  const day = this.getDate()
  const week = this.getDay()
  const hour = this.getHours()
  const minute = this.getMinutes()
  const second = this.getSeconds()

  return fmt.replace(/Y{2,4}|M{1,2}|D{1,2}|d{1,4}|H{1,2}|m{1,2}|s{1,2}/g, (match) => {
    switch (match) {
      case 'YY':
        return year.toString().slice(-2)
      case 'YYY':
      case 'YYYY':
        return year
      case 'M':
        return month
      case 'MM':
        return month >= 10 ? month : `0${month}`
      case 'D':
        return day
      case 'DD':
        return day >= 10 ? day : `0${day}`
      case 'd':
        return week
      case 'dd':
        return weeks[week]
      case 'ddd':
        return '周' + weeks[week]
      case 'dddd':
        return '星期' + weeks[week]
      case 'H':
        return hour
      case 'HH':
        return hour >= 10 ? hour : `0${hour}`
      case 'm':
        return minute
      case 'mm':
        return minute >= 10 ? minute : `0${minute}`
      case 's':
        return second
      case 'ss':
        return second >= 10 ? second : `0${second}`
      default:
        return match
    }
  })
}

/**
 * 防抖函数，返回函数连续调用时，空闲时间必须大于或等于 wait，func 才会执行
 *
 * @param  {function} func        回调函数
 * @param  {number}   wait        表示时间窗口的间隔
 * @param  {boolean}  immediate   设置为ture时，是否立即调用函数
 * @return {function}             返回客户调用函数
 */
export const debounce = function(func, wait = 50, immediate = true) {
  let timer, context, args
  const later = () =>
    setTimeout(() => {
      timer = null
      if (!immediate) {
        func.apply(context, args)
        context = args = null
      }
    }, wait)
  return function(...params) {
    if (!timer) {
      timer = later()
      if (immediate) {
        func.apply(this, params)
      } else {
        context = this
        args = params
      }
    } else {
      clearTimeout(timer)
      timer = later()
    }
  }
}

//判断切克app
export const isCheckApp = (function() {
  const ua = window.navigator.userAgent
  return ua.toLowerCase().indexOf('checkapp') > 0
})()

//判断卖家app
export const isZhuanzhuanSeller = (function() {
  // const ua = window.navigator.userAgent;
  // return ua.toLowerCase().indexOf('zhuanzhuanseller') > 0;
  return native.client === 'zzseller'
})()
//判断采货侠app
export const isHunterApp = (function() {
  // const ua = window.navigator.userAgent;
  return native.client === 'zzhunter' || +getCookie('t') === 134 || +getCookie('t') === 72 || +getCookie('t') === 73
})()
//判断主app
export const isZhuanzhuan = (function() {
  // const ua = window.navigator.userAgent;
  // return ua.toLowerCase().indexOf('zhuanzhuan') > 0; //无法区分卖家app和主APP。
  return native.client === 'zz'
})()

//判断统跳协议头
export const adapterSchema = (function() {
  let adapterSchema = 'zhuanzhuan'
  if (isCheckApp) {
    adapterSchema = 'zzcheck'
  }
  if (isHunterApp) {
    adapterSchema = 'zzhunter'
  }
  if (isZhuanzhuanSeller) {
    adapterSchema = 'zhuanzhuanseller'
  }
  return adapterSchema
})()

//转换pics
export const tranUrl = (src) => {
  return src.slice(src.indexOf('zhuanzh/') + 8, src.length)
}

export const tranPics = (pics) => {
  const picUrls = pics.reduce((total, cur) => [...total, tranUrl(cur.url)], [])
  return picUrls
}

export const isZlj = () => {
  return native.in('zlj')
}

export function closeZljRefresh() {
  if (isZlj()) {
    native.wrap('switchRefresh')(false)
  }
}
export function hideShareButton() {
  if (isZlj()) {
    // 找靓机新webview下，默认隐藏
    if (env.$isZljNewWebview) {
      // native.wrap('zljHideShareButton')(true)
    } else {
      native.wrap('hideShareButton')(true)
    }
  }
}
export const getZljUid = () => {
  return new Promise((resolve, reject) => {
    if (isZlj()) {
      zljSilenceLogin(resolve, reject)
    } else {
      return ''
    }
  })
}

// 找靓机用户静默登录逻辑
export function zljSilenceLogin(resolve, reject) {
  native.wrap('checkLogin')({
    success: (isLogin) => {
      if (isLogin) {
        zljUserExchangeZZUserInfo(resolve, reject)
      } else {
        // 清理转转可能存在的cookie (uid PPU)
        setCookie('uid', '')
        setCookie('PPU', '')
        resolve(false)
      }
    }
  })
}

// 找靓机用户换回转转用户信息
export function zljUserExchangeZZUserInfo(resolve, reject) {
  native.wrap('getUserInfo')({
    success: (res) => {
      console.log('getUserInfo--res: ', res)
      if (!res) {
        const now = new Date()
        console.log('读取APP用户信息失败:getUserInfo method error!' + now + '.' + now.getMilliseconds())
        resolve(false)
        return
      }
      const { token, userId } = res
      zljUserLogin({
        zljToken: token,
        zljUid: userId
      })
        .then((ret) => {
          const { uid, ppu } = ret
          // 将uid和PPU塞进cookie中
          native.wrap('getContextInfo')({
            success: (res) => {
              const { deviceId } = res
              setCookie('uid', uid)
              setCookie('PPU', `"${ppu}"`, 20, false)
              alert('找靓机用户换回转转用户信息')
              setCookie('deviceId', deviceId) // 因为找靓机在登录后,清理了所有的cookie,所以无法保留tempUid,所以传递deviceId作为替代
              setTimeout(() => {
                resolve({ uid, ppu })
              }, 200)
            }
          })
        })
        .catch((e) => {
          console.log('失败error：', e)
          alert('交换uid失败!')
          reject(e)
        })
    }
  })
}

/**
 * 强制登录,无论是找靓机还是转转
 */
export function forceLogin() {
  return new Promise((resolve, reject) => {
    if (getCookie('PPU') && parseInt(getCookie('uid'), 10) > 0) {
      resolve()
      return
    }
    if (isZlj()) {
      zljForceLogin(resolve, reject)
    } else {
      zzForceLogin(resolve, reject)
    }
  })
}

// 拉起找靓机小窗口登录
function zljForceLogin(resolve, reject) {
  native.wrap('login')((res) => {
    if (Number(res.code) !== 0) {
      reject(res)
      alert('找靓机APP登录失败!')
    } else {
      zljUserExchangeZZUserInfo(resolve, reject)
    }
  })
}

// 转转用户登录逻辑
function zzForceLogin(resolve, reject) {
  native.wrap('login')((res) => {
    if (Number(res.code) !== 0) {
      //  res.code == -100    登录失败
      //  res.code == -1      登录失败，比如用户取消，不做任何处理
      reject(res)
      return
    }
    //  在 iOS 下刚登陆后存在没有 cookie 的情况
    if (deviceType.iOS) {
      native.wrap('getCookie')(() => {})
      const startTime = new Date().getTime()
      const timer = setInterval(() => {
        const uid = getCookie('uid')
        const diffTime = new Date().getTime() - startTime
        if (diffTime > 1000 || uid) {
          console.log('got uid: ', uid)
          clearInterval(timer)
          resolve()
        }
      }, 100)
    } else {
      resolve()
    }
  })
}

export const awaitWrap = (promise) => {
  return promise
    .then(data => [null, data])
    .catch(err => [err, null])
}

export const skipClose = (targetUrl) => {
  if (isZlj()) {
    if (isIOS) {
      return window.location.replace(targetUrl)
    }
    setTimeout(() => {
      native.close();
    }, 100)
    return native.skipToUrl({
      targetUrl
    })
  }
  return native.skipToUrl({
    targetUrl,
    needClose: '1'
  })
}

/**
 * 是否是找靓机环境
 */
export const isZljNative = () => {
  return native.in('zlj')
}

/**
 * 是否是找靓机小程序环境
 */
export const isZljWx = () => {
  return queryParams().__t === '141'
}

/**
 * 是否是找靓机H5入口进来的
 */
export const isZljHtml = () => {
  return queryParams().isZljHtml === '1'
}
/**
 * 获取全平台转转uid，例如58侧取转转uid，
 * 依次取 cookie.uid -> cookie.ZZU.UID -> cookie.PPU.UID
 */
export function getAdaptedUid() {
  return cookie.getUid()
}

export const getPlatform = () => {
  const querys = queryParams()
  // 找靓机native 找靓机小程序 找靓机端外H5页面都有不同的处理逻辑，所以分开判断，但使用同一套UI
  if (isZljNative() || isZljWx() || isZljHtml()) return 'zlj'
  const { isTencentWhs } = querys
  if (+isTencentWhs === 1) return 'whs' // 腾讯微回收 whs = 微回收
  return native.client || 'zz' // 获取当前客户端平台，默认为转转
}

const UA = window.navigator.userAgent
const sHeight = window.screen.height
export const isZZ = UA.toLowerCase().indexOf('zhuanzhuan') > 0

export const isIOS = !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

export const isAndroid = UA.indexOf('Android') > -1 || UA.indexOf('Adr') > -1

export const isIphoneX = isIOS && sHeight >= 812

const compatibleRAF = (function() {
  if (requestAnimationFrame) return window.requestAnimationFrame
  return function(callback) {
    console.log('难不成走到这里了？？？底部的按钮？？？target')
    window.setTimeout(callback, 16)
  }
})()

export const RAFMove = function(processDo, target, time = 1000) {
  const start = Date.now()
  function move() {
    const now = Date.now()
    const process = (now - start) / time
    console.log('回到底部的按钮？？？process', process)
    if (process < 1) {
      processDo(process)
      compatibleRAF(move)
    } else {
      target()
      console.log('回到底部的按钮？？？target')
    }
  }
  compatibleRAF(move)
}

export function AESencrypt(content, key, iv, isNeedBase64 = true) {
  //十六位十六进制数
  const _key = CryptoJS.enc.Utf8.parse(key)
  //十六位十六进制数
  const _iv = CryptoJS.enc.Utf8.parse(iv)
  const isObject = Object.prototype.toString.call(content) == '[object Object]'
  const _data = isObject ? CryptoJS.enc.Utf8.parse(JSON.stringify(content)) : CryptoJS.enc.Utf8.parse(content)
  const encrypted = CryptoJS.AES.encrypt(_data, _key, {
    iv: _iv,
    mode: CryptoJS.mode.CBC, // 加密模式
    padding: CryptoJS.pad.Pkcs7
  })
  const encryptedvalue = isNeedBase64 ? CryptoJS.enc.Base64.stringify(encrypted.ciphertext) : encrypted.ciphertext.toString()
  return encryptedvalue
}

//鸿蒙人脸功能要8月才提供,过渡过程中给予提示
export function compatibleHarmony() {
  if (getCookie('t') == 20 && !compareVersion(getCookie('v') || '', '10.30.10')) {
    Toast('当前版本不支持人脸核验，请升级至最新版本后操作')
    return true;
  }
  return false
}

export function isHeroClubByUa() {
  const ua = navigator.userAgent
  return /zzheroclub/.test(ua)
}